"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.fluid = exports.obstacles = exports.display = exports.brush = exports.bind = exports.mouse = void 0;
var Requirements = __importStar(require("./requirements"));
require("./page-interface-generated");
var Mouse = (function () {
    function Mouse() {
        var _this = this;
        this._posInPx = [0, 0];
        this._pivotInPx = [0, 0];
        this.setPosInPx([0, 0]);
        this.setMovementInPx([0, 0]);
        Page.Canvas.Observers.mouseMove.push(function (relX, relY) {
            var canvasSize = Page.Canvas.getSize();
            _this.setPosInPx([canvasSize[0] * relX, canvasSize[1] * (1 - relY)]);
        });
        Page.Canvas.Observers.mouseDown.push(function () {
            _this.setMovementInPx([0, 0]);
            _this._pivotInPx = _this._posInPx;
        });
    }
    Object.defineProperty(Mouse.prototype, "posInPx", {
        get: function () {
            return this._posInPx;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Mouse.prototype, "pos", {
        get: function () {
            return this._pos;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Mouse.prototype, "movementInPx", {
        get: function () {
            return this._movementInPx;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Mouse.prototype, "movement", {
        get: function () {
            return this._movement;
        },
        enumerable: false,
        configurable: true
    });
    Mouse.prototype.setPosInPx = function (pos) {
        var toPivot = [
            this._pivotInPx[0] - pos[0],
            this._pivotInPx[1] - pos[1]
        ];
        var distToPivot = Math.sqrt(toPivot[0] * toPivot[0] + toPivot[1] * toPivot[1]);
        var maxDist = 16;
        if (distToPivot > maxDist) {
            toPivot[0] *= maxDist / distToPivot;
            toPivot[1] *= maxDist / distToPivot;
            this._pivotInPx[0] = pos[0] + toPivot[0];
            this._pivotInPx[1] = pos[1] + toPivot[1];
        }
        var movementInPx = [-toPivot[0] / maxDist, -toPivot[1] / maxDist];
        this.setMovementInPx(movementInPx);
        this._posInPx = pos;
        this._pos = this.setRelative(pos);
    };
    Mouse.prototype.setMovementInPx = function (movement) {
        this._movementInPx = movement;
        this._movement = this.setRelative(movement);
    };
    Mouse.prototype.setRelative = function (pos) {
        var canvasSize = Page.Canvas.getSize();
        return [
            pos[0] / canvasSize[0],
            pos[1] / canvasSize[1],
        ];
    };
    return Mouse;
}());
var mouse = new Mouse();
exports.mouse = mouse;
function bindMouse() {
    exports.mouse = mouse = new Mouse();
}
var brushInfo = {
    radius: 10,
    strength: 100,
};
exports.brush = brushInfo;
var fluidInfo = {
    stream: true,
};
exports.fluid = fluidInfo;
var ObstaclesInfo;
(function (ObstaclesInfo) {
    ObstaclesInfo["NONE"] = "none";
    ObstaclesInfo["ONE"] = "one";
    ObstaclesInfo["MANY"] = "many";
})(ObstaclesInfo || (ObstaclesInfo = {}));
var obstaclesInfo = ObstaclesInfo.NONE;
exports.obstacles = obstaclesInfo;
var displayInfo = {
    velocity: true,
    pressure: true,
    brush: true,
    obstacles: true,
};
exports.display = displayInfo;
function bindControls(fluid) {
    {
        var RESOLUTIONS_CONTROL_ID = "resolution";
        var updateResolution = function (values) {
            var size = +values[0];
            fluid.reset(size, size);
        };
        Page.Tabs.addObserver(RESOLUTIONS_CONTROL_ID, updateResolution);
        updateResolution(Page.Tabs.getValues(RESOLUTIONS_CONTROL_ID));
    }
    {
        var FLOAT_CONTROL_ID = "float-texture-checkbox-id";
        if (!Requirements.allExtensionsLoaded) {
            Page.Controls.setVisibility(FLOAT_CONTROL_ID, false);
            Page.Checkbox.setChecked(FLOAT_CONTROL_ID, false);
        }
        var updateFloat = function (use) { fluid.useFloatTextures = use; };
        Page.Checkbox.addObserver(FLOAT_CONTROL_ID, updateFloat);
        updateFloat(Page.Checkbox.isChecked(FLOAT_CONTROL_ID));
    }
    {
        var ITERATIONS_CONTROL_ID = "solver-steps-range-id";
        var updateIterations = function (iterations) { fluid.minNbIterations = iterations; };
        Page.Range.addObserver(ITERATIONS_CONTROL_ID, updateIterations);
        updateIterations(Page.Range.getValue(ITERATIONS_CONTROL_ID));
    }
    {
        var TIMESTEP_CONTROL_ID = "timestep-range-id";
        var updateTimestep = function (timestep) { fluid.timestep = timestep; };
        Page.Range.addObserver(TIMESTEP_CONTROL_ID, updateTimestep);
        updateTimestep(Page.Range.getValue(TIMESTEP_CONTROL_ID));
    }
    {
        var STREAM_CONTROL_ID = "stream-checkbox-id";
        var updateStream = function (doStream) { fluidInfo.stream = doStream; };
        Page.Checkbox.addObserver(STREAM_CONTROL_ID, updateStream);
        updateStream(Page.Checkbox.isChecked(STREAM_CONTROL_ID));
    }
    {
        var OBSTACLES_CONTROL_ID = "obstacles";
        var updateObstacles = function (values) {
            exports.obstacles = obstaclesInfo = values[0];
        };
        Page.Tabs.addObserver(OBSTACLES_CONTROL_ID, updateObstacles);
        updateObstacles(Page.Tabs.getValues(OBSTACLES_CONTROL_ID));
    }
    {
        var BRUSH_RADIUS_CONTROL_ID_1 = "brush-radius-range-id";
        var updateBrushRadius_1 = function (radius) { brushInfo.radius = radius; };
        Page.Range.addObserver(BRUSH_RADIUS_CONTROL_ID_1, updateBrushRadius_1);
        updateBrushRadius_1(Page.Range.getValue(BRUSH_RADIUS_CONTROL_ID_1));
        Page.Canvas.Observers.mouseWheel.push(function (delta) {
            Page.Range.setValue(BRUSH_RADIUS_CONTROL_ID_1, brushInfo.radius + 5 * delta);
            updateBrushRadius_1(Page.Range.getValue(BRUSH_RADIUS_CONTROL_ID_1));
        });
    }
    {
        var BRUSH_STRENGTH_CONTROL_ID = "brush-strength-range-id";
        var updateBrushStrength = function (strength) { brushInfo.strength = strength; };
        Page.Range.addObserver(BRUSH_STRENGTH_CONTROL_ID, updateBrushStrength);
        updateBrushStrength(Page.Range.getValue(BRUSH_STRENGTH_CONTROL_ID));
    }
    {
        var DISPLAY_MODE_CONTROL_ID = "displayed-fields";
        var updateDisplayMode = function (modes) {
            displayInfo.velocity = modes[0] === "velocity" || modes[1] === "velocity";
            displayInfo.pressure = modes[0] === "pressure" || modes[1] === "pressure";
        };
        Page.Tabs.addObserver(DISPLAY_MODE_CONTROL_ID, updateDisplayMode);
        updateDisplayMode(Page.Tabs.getValues(DISPLAY_MODE_CONTROL_ID));
    }
    {
        var COLOR_INTENSITY_CONTROL_ID = "intensity-range-id";
        var updateColorIntensity = function (intensity) { fluid.colorIntensity = intensity; };
        Page.Range.addObserver(COLOR_INTENSITY_CONTROL_ID, updateColorIntensity);
        updateColorIntensity(Page.Range.getValue(COLOR_INTENSITY_CONTROL_ID));
    }
    {
        var DISPLAY_COLOR_CONTROL_ID = "display-color-checkbox-id";
        var updateColor = function (display) { fluid.color = display; };
        Page.Checkbox.addObserver(DISPLAY_COLOR_CONTROL_ID, updateColor);
        updateColor(Page.Checkbox.isChecked(DISPLAY_COLOR_CONTROL_ID));
    }
    {
        var DISPLAY_OBSTACLES_CONTROL_ID = "display-obstacles-checkbox-id";
        var updateDisplayObstacles = function (display) { displayInfo.obstacles = display; };
        Page.Checkbox.addObserver(DISPLAY_OBSTACLES_CONTROL_ID, updateDisplayObstacles);
        updateDisplayObstacles(Page.Checkbox.isChecked(DISPLAY_OBSTACLES_CONTROL_ID));
    }
}
function bind(fluid) {
    bindControls(fluid);
    bindMouse();
}
exports.bind = bind;
